import React from 'react';
import { Button, Col, Form, Input, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLogin } from '../../store/ducks/user/userSlice';
import { useMutation } from '@tanstack/react-query';
import { loginRequest } from '../../services/authRequest';

const { Text } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { mutate: mutateLogin, isLoading } = useMutation({
    mutationFn: loginRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        await dispatch(setLogin(data?.data));
        notification.success({ message: 'Đăng nhập thành công!' });
        form.resetFields();
        navigate('/');
      } else {
        notification.error({
          message: data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = async (data) => {
    mutateLogin(data);
  };

  return (
    <div className="h-screen w-full flex justify-center items-center">
      <div className="w-[440px] px-10 pb-24 shadow-lg drop-shadow bg-white rounded">
        <Typography.Title className={'font-bold text-center py-4 border-b mb-10'}>
          Admin <span className={'font-normal'}>Lịch Việt</span>
        </Typography.Title>
        <Form
          name="login"
          form={form}
          layout="vertical"
          requiredMark={false}
          className="mb-5"
          onFinish={handleSubmitForm}
        >
          <Col xs={24}>
            <Form.Item
              name="username"
              label={
                <Text>
                  Tên đăng nhập <span className="text-red-700">*</span>
                </Text>
              }
              rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập' }]}
            >
              <Input placeholder="Nhập tên đăng nhập" className="h-[50px]" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              name="password"
              label={
                <Text>
                  Mật khẩu <span className="text-red-700">*</span>
                </Text>
              }
              rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]}
            >
              <Input.Password placeholder="Nhập mật khẩu" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Button block loading={isLoading} htmlType="submit" type="primary">
              Đăng nhập
            </Button>
          </Col>
        </Form>
      </div>
    </div>
  );
};
export default Login;
